import { FerienhausProdukt } from "@/model/FerienhausProdukt";

export class Ferienhaus {
  versicherungsumfang = "";
  vorschaedenVorhanden = 0;
  oertlicheLage = 0;
  kontrolleHausverwaltung: boolean | null;
  vgv = new FerienhausProdukt();
  vhv = new FerienhausProdukt();
  hug = new FerienhausProdukt();

  //Frontend-spezifische Erweiterung
  bezugfertigDatum = "";

  constructor() {
    this.kontrolleHausverwaltung = null;
  }
}
